module.exports = __webpack_public_path__ + "media/images/sp/top/soudan_online@3x-3aa59fbad7451a42b59b1b59c677a69d.webp";